import ActionButtonGroup, { ActionButtonConfig } from "../../shared/ActionButtonGroup";
import {
    Cancel,
    Delete,
    Edit,
    Save
    } from "@mui/icons-material";

interface ActionButtonsProps {
  mode: "view" | "edit";
  disabled?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
}

export default function ParticipantActionButtons({
  mode,
  disabled = false,
  onEdit,
  onDelete,
  onSave,
  onCancel,
}: ActionButtonsProps) {
  const getButtons = (): ActionButtonConfig[] => {
    if (mode === "edit") {
      return [
        {
          id: "save",
          label: "Zapisz",
          icon: <Save />,
          variant: "contained",
          color: "success",
          onClick: onSave,
          sx: {
            backgroundColor: "#10b981",
            "&:hover": { backgroundColor: "#059669" },
          },
        },
        {
          id: "cancel",
          label: "Anuluj",
          icon: <Cancel />,
          variant: "outlined",
          onClick: onCancel,
          sx: {
            color: "#6b7280",
            borderColor: "#6b7280",
            "&:hover": { backgroundColor: "#f3f4f6", borderColor: "#6b7280" },
          },
        },
      ];
    }

    return [
      {
        id: "edit",
        label: "Edytuj",
        icon: <Edit />,
        variant: "outlined",
        disabled,
        onClick: onEdit,
        sx: {
          color: "#6366f1",
          borderColor: "#6366f1",
          "&:hover": { backgroundColor: "#f1e7de", borderColor: "#6366f1" },
          "&:disabled": { color: "#9ca3af", borderColor: "#9ca3af" },
        },
      },
      {
        id: "delete",
        label: "Usuń",
        icon: <Delete />,
        variant: "outlined",
        color: "error",
        disabled,
        onClick: onDelete,
        sx: {
          color: "#ef4444",
          borderColor: "#ef4444",
          "&:hover": { backgroundColor: "#fef2f2", borderColor: "#ef4444" },
          "&:disabled": { color: "#9ca3af", borderColor: "#9ca3af" },
        },
      },
    ];
  };

  return (
    <ActionButtonGroup
      buttons={getButtons()}
      justifyContent="flex-end"
      sx={{
        justifyContent: { xs: "stretch", md: "flex-end" },
      }}
    />
  );
}
